<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="setupSelectItems"
            v-model="item.setup"
            :items="setupSelectItems"
            :error-messages="setupErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.profileparameter.setup')"
            item-text="uuid"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="strategySelectItems"
            v-model="item.strategy"
            :items="strategySelectItems"
            :error-messages="strategyErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.profileparameter.strategy')"
            item-text="uuid"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <!-- todo : fix the dateTime format, not supported by default on vuetify -->
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.date"
            :label="$t('profile.profileparameter.date')"
            :error-messages="dateErrors"
            required
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.version"
            :error-messages="versionErrors"
            :label="$t('profile.profileparameter.version')"
            required
            @input="$v.item.version.$touch()"
            @blur="$v.item.version.$touch()"
          />
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import InputDate from '../InputDate';
import Loading from '../../components/Loading';

export default {
  name: 'ProfileParameterSetForm',
  mixins: [validationMixin],
  components: {
    InputDate,
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.setupGetSelectItems();
      this.strategyGetSelectItems();
      this.profileParameterSetValuesGetSelectItems();
  },
  data() {
    return {
        setup: null,
        strategy: null,
        date: null,
        version: null,
        profileParameterSetValues: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_setupdefinition ||
           this.isLoading_profilestrategy ||
           this.isLoading_profileparametersetvalue 
         );
      },
      ...mapFields('setupdefinition', {
        setupSelectItems: 'selectItems',
        isLoading_setupdefinition : 'isLoading'
      }),
      ...mapFields('profilestrategy', {
        strategySelectItems: 'selectItems',
        isLoading_profilestrategy : 'isLoading'
      }),
      ...mapFields('profileparametersetvalue', {
        profileParameterSetValuesSelectItems: 'selectItems',
        isLoading_profileparametersetvalue : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    setupErrors() {
      const errors = [];

      if (!this.$v.item.setup.$dirty) return errors;

      has(this.violations, 'setup') && errors.push(this.violations.setup);


      return errors;
    },
    strategyErrors() {
      const errors = [];

      if (!this.$v.item.strategy.$dirty) return errors;

      has(this.violations, 'strategy') && errors.push(this.violations.strategy);


      return errors;
    },
    dateErrors() {
      const errors = [];

      if (!this.$v.item.date.$dirty) return errors;

      has(this.violations, 'date') && errors.push(this.violations.date);

      !this.$v.item.date.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    versionErrors() {
      const errors = [];

      if (!this.$v.item.version.$dirty) return errors;

      has(this.violations, 'version') && errors.push(this.violations.version);

      !this.$v.item.version.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    profileParameterSetValuesErrors() {
      const errors = [];

      if (!this.$v.item.profileParameterSetValues.$dirty) return errors;

      has(this.violations, 'profileParameterSetValues') && errors.push(this.violations.profileParameterSetValues);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        setupGetSelectItems: 'setupdefinition/fetchSelectItems'
      }),
      ...mapActions({
        strategyGetSelectItems: 'profilestrategy/fetchSelectItems'
      }),
      ...mapActions({
        profileParameterSetValuesGetSelectItems: 'profileparametersetvalue/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      setup: {
      },
      strategy: {
      },
      date: {
        required,
      },
      version: {
        required,
      },
      profileParameterSetValues: {
      },
    }
  }
};
</script>
